module.exports = __webpack_public_path__ + "static/media/product_sweets.1fe7b959.png";